import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs';
import { Router, NavigationEnd } from '@angular/router';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';
import { AccountInfoService, UserAccountService } from 'degarmo-lib';
import { HelpTicketService } from 'degarmo-lib';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems: MenuItem[] = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private userAccountService: UserAccountService,
    private accountInfoService: AccountInfoService,
    private helpTicketService: HelpTicketService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();

    this.userAccountService.subscribeToLoginChanged(() => {
      this._checkLinkVisibilities();
    });
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName('mm-active').length > 0) {
        const currentPosition = document.getElementsByClassName('mm-active')[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null) this.scrollRef.SimpleBar.getScrollElement().scrollTop = currentPosition + 300;
      }
    }, 300);
  }

  /**
   * Check all menu items based on the current user information: securityID, companyID, etc.
   */
  _checkLinkVisibilities = async () => {
    let visibleCount: number = 0;
    for (const menuItem of this.menuItems) {
      visibleCount = 0;
      if (menuItem.subItems && menuItem.subItems.length > 0) {
        for (const subItem of menuItem.subItems) {
          subItem.isVisible = await this.userAccountService.getPermittedView(
            subItem.allowedUserGroups,
            subItem.allowedSecurityLevelIDs,
            subItem.allowedCompanyIDs,
            subItem.link
          );

          if (subItem.isVisible === true) visibleCount++;
        }

        menuItem.isVisible = visibleCount > 0;
      }
    }
  };

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];

    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }

    const itemIndex = paths.indexOf(window.location.pathname);

    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }

    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;

      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) {
              childAnchor.classList.add('mm-active');
            }
            if (childDropdown) {
              childDropdown.classList.add('mm-active');
            }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Set the active parent item class name when for an impersonating user.
   */
  /*
  _setActiveMenuItemForImpersonation() {
    setTimeout(() => {
      const userLoginInfo = this.accountInfoService.getUserLoginInfo();
      if (userLoginInfo && userLoginInfo.isImpersonating) {
        this.initialize();
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
        this._checkLinkVisibilities();
        this._activateMenuDropdown();
      }
      }, 800);
  }
  */

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = [];
    this.menuItems = MENU;
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Handle the click by its action name if exists
   */
  handleActionClicked = (actionName: string) => {
    switch (actionName) {
      case 'helpTicket':
        this.helpTicketService.openHelpTicketModal();
        break;
    }
  };
}
